import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import PhoneBindingModalStore from './store';

const styles = require('./index.less');
const PHONE_SETTING_URL = 'https://security.xoyo.com/phone-setting';

const PhoneBindingModal = ({ store, onClose }) => {
  store.use();
  store.onClose = onClose;
  return (
    <ModalContainer modalState={store.isOpen}>
      <section className={styles.panel} aria-label="未绑定手机提示">
        <button className={styles.close} type="button" aria-label="关闭" onClick={store.onClickClose}>
          <span>关闭</span>
        </button>
        <a
          className={styles.confirm}
          href={PHONE_SETTING_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="去绑定手机"
          onClick={store.onBindPhoneClick}
        >
          <span>去绑定手机</span>
        </a>
        <button className={styles.bound} type="button" onClick={store.onHaveBoundPhoneClick} aria-label="我已绑定手机">
          <span>我已绑定手机</span>
        </button>
      </section>
    </ModalContainer>
  );
};

export default wrapStore(PhoneBindingModal, PhoneBindingModalStore);
